import React, { useState, createContext, useContext } from "react";
import Toast from './components/toast';

export const ToastContext = createContext();

export const Toaster = ({children}) => {
  const [message, setMessage] = useState('');
  const [key, setKey] = useState(0);
  const [type, setType] = useState('');

  const show = (type, message) => {
    setType(type);
    setMessage(message);
    setKey(key + 1);
  };

  const info = message => show('info', message);
  const error = message => show('error', message);

  return (
    <ToastContext.Provider value={{info, error}}>
      {children}
      {key != 0 && <Toast key={key} type={type}>{message}</Toast>}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
